import styled from "@emotion/styled";
import Dialog from "@mui/material/Dialog";

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 4% -8%,
      rgba(59, 130, 246, 0.14) 0%,
      transparent 35%
    ),
    radial-gradient(
      circle at 98% 106%,
      rgba(14, 165, 233, 0.12) 0%,
      transparent 42%
    ),
    var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 14px;
  }

  .new-modal-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .save-onboarding-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .segment-control-row {
    display: flex;
    justify-content: flex-start;
  }

  .segment-control-row .MuiToggleButtonGroup-root {
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    padding: 2px;
  }

  .segment-control-row .MuiToggleButton-root {
    text-transform: none;
    font-weight: 700;
    border: 0;
    color: var(--cms-text-secondary);
    border-radius: 10px;
    padding: 6px 12px;
  }

  .segment-control-row .MuiToggleButton-root.Mui-selected {
    background: var(--cms-selected-bg);
    color: var(--cms-text-primary);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18);
  }

  .modal-link-cell {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    min-width: 220px;

    a {
      color: #1976d2;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      font-weight: 600;
    }
  }

  .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .MuiTableCell-head {
    background: var(--cms-surface-muted);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .table-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 36px;
    padding: 6px 12px;
  }

  .empty-row {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .onboarding-panel {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .onboarding-card {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    padding: 12px;
  }

  .card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .card-title {
    margin: 0;
    font-size: 16px;
    color: var(--cms-text-primary);
    font-weight: 800;
    letter-spacing: -0.01em;
  }

  .card-subtitle {
    margin: 2px 0 0;
    color: var(--cms-text-secondary);
    font-size: 12px;
    font-weight: 500;
  }

  .updated-at {
    color: var(--cms-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }

  .trigger-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 10px;
  }

  .toggle-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 8px 10px;
  }

  .toggle-item {
    margin: 0;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-secondary);
    padding: 6px 10px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .toggle-item .MuiFormControlLabel-label {
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 600;
  }

  .toggle-item.global-toggle {
    grid-column: 1 / span 2;
    border-color: var(--cms-border);
    background: var(--cms-selected-bg);
  }

  .rotation-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .rotation-item {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    padding: 10px;
  }

  .rotation-item-title {
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .rotation-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 8px;
  }

  .rotation-grid .rotation-highlights {
    grid-column: 1 / span 2;
  }

  /* ---------- Welcome Series page (day-by-day tour) ---------- */

  .ws-hero {
    border-radius: 18px;
    padding: 18px 20px;
    background: linear-gradient(135deg, #1d4ed8 0%, #4f46e5 60%, #7c3aed 100%);
    color: #ffffff;
    box-shadow: 0 18px 36px rgba(30, 64, 175, 0.22);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ws-hero-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .ws-hero-sub {
    margin: 0;
    font-size: 13px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.92);
    max-width: 780px;
  }

  .ws-hero-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    margin-top: 6px;
    font-size: 12px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.92);
  }

  .ws-hero-stat-chip {
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.24);
    border-radius: 999px;
    padding: 4px 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .ws-section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 18px 0 10px;
  }

  .ws-section-title::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, var(--cms-border) 0%, transparent 100%);
  }

  .ws-control-card {
    border: 1px solid var(--cms-border);
    border-radius: 16px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.06);
    padding: 16px 18px;
    display: grid;
    grid-template-columns: 1.4fr 1fr;
    gap: 18px;
    align-items: center;
  }

  @media (max-width: 900px) {
    .ws-control-card {
      grid-template-columns: 1fr;
    }
  }

  .ws-control-toggle-block h4 {
    margin: 0 0 4px;
    color: var(--cms-text-primary);
    font-size: 16px;
    font-weight: 800;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ws-control-toggle-block p {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 12.5px;
    line-height: 1.5;
  }

  .ws-control-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    padding: 10px 12px;
    margin-top: 10px;
  }

  .ws-pulse-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.18);
  }

  .ws-pulse-dot.off {
    background: #94a3b8;
    box-shadow: 0 0 0 4px rgba(148, 163, 184, 0.18);
  }

  .ws-control-delay h4 {
    margin: 0 0 4px;
    color: var(--cms-text-primary);
    font-size: 15px;
    font-weight: 800;
  }

  .ws-control-delay p {
    margin: 0 0 8px;
    color: var(--cms-text-secondary);
    font-size: 12.5px;
    line-height: 1.5;
  }

  .ws-glance {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 8px;
    margin-bottom: 16px;
  }

  @media (max-width: 1100px) {
    .ws-glance {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (max-width: 600px) {
    .ws-glance {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .ws-glance-pill {
    border-radius: 12px;
    border: 1px solid transparent;
    background: var(--cms-surface-muted);
    padding: 8px 10px;
    text-align: center;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    cursor: pointer;
  }

  .ws-glance-pill:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 16px rgba(15, 23, 42, 0.06);
  }

  .ws-glance-pill .label {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--cms-text-secondary);
  }

  .ws-glance-pill .value {
    margin-top: 2px;
    font-size: 12.5px;
    font-weight: 700;
    color: var(--cms-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ws-glance-pill.is-active {
    border-color: var(--cms-border);
    background: var(--cms-selected-bg);
  }

  .ws-glance-pill.is-off {
    opacity: 0.55;
  }

  .ws-day-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .ws-day-card {
    border-radius: 16px;
    background: var(--cms-surface-secondary);
    border: 1px solid var(--cms-border);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    padding: 16px 18px;
    display: grid;
    grid-template-columns: 96px 1fr;
    gap: 16px;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
  }

  .ws-day-card.disabled {
    opacity: 0.7;
    background: var(--cms-surface-muted);
  }

  .ws-day-card:hover {
    border-color: var(--cms-border);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
  }

  @media (max-width: 700px) {
    .ws-day-card {
      grid-template-columns: 1fr;
    }
  }

  .ws-day-badge {
    border-radius: 14px;
    background: linear-gradient(160deg, #1d4ed8 0%, #4f46e5 100%);
    color: #ffffff;
    padding: 12px 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 96px;
  }

  .ws-day-badge .day-eyebrow {
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    opacity: 0.85;
  }

  .ws-day-badge .day-num {
    font-size: 30px;
    font-weight: 800;
    line-height: 1;
    margin-top: 2px;
  }

  .ws-day-badge.tone-engagement {
    background: linear-gradient(160deg, #0ea5e9 0%, #2563eb 100%);
  }

  .ws-day-badge.tone-content {
    background: linear-gradient(160deg, #8b5cf6 0%, #6d28d9 100%);
  }

  .ws-day-badge.tone-upgrade {
    background: linear-gradient(160deg, #f59e0b 0%, #d97706 100%);
  }

  .ws-day-badge.tone-none {
    background: linear-gradient(160deg, #94a3b8 0%, #64748b 100%);
  }

  .ws-day-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .ws-day-head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    justify-content: space-between;
  }

  .ws-day-head-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
  }

  .ws-day-pill-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  .ws-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 999px;
    padding: 3px 9px;
    font-size: 10.5px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .ws-pill.tone-on {
    background: #d1fae5;
    color: #065f46;
  }

  .ws-pill.tone-off {
    background: #e2e8f0;
    color: #475569;
  }

  .ws-pill.tone-popup {
    background: #dbeafe;
    color: #1e40af;
  }

  .ws-pill.tone-no-popup {
    background: #f1f5f9;
    color: #64748b;
  }

  .ws-pill.tone-upgrade {
    background: #fef3c7;
    color: #92400e;
  }

  .ws-pill.tone-content {
    background: #ede9fe;
    color: #5b21b6;
  }

  .ws-pill.tone-engagement {
    background: #cffafe;
    color: #155e75;
  }

  .ws-pill.tone-skip {
    background: #ffe4e6;
    color: #9f1239;
  }

  .ws-day-actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .ws-day-actions .ws-preview-btn {
    border-color: var(--cms-border);
    color: var(--cms-text-primary);
    font-size: 11px;
    font-weight: 800;
    text-transform: none;
    white-space: nowrap;
  }

  .ws-input-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .ws-input-grid .ws-full {
    grid-column: 1 / -1;
  }

  .ws-media-panel {
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background:
      radial-gradient(circle at top left, rgba(59, 130, 246, 0.1), transparent 34%),
      var(--cms-surface-muted);
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ws-media-title {
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--cms-text-primary);
  }

  .ws-media-subtitle {
    margin-top: 2px;
    color: var(--cms-text-secondary);
    font-size: 12px;
    line-height: 1.45;
  }

  @media (max-width: 700px) {
    .ws-input-grid {
      grid-template-columns: 1fr;
    }
  }

  .ws-toggle-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .ws-toggle-helper {
    font-size: 12px;
    color: var(--cms-text-secondary);
    line-height: 1.4;
    flex: 1;
    min-width: 220px;
  }

  .ws-toggle-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px 5px 6px;
    border-radius: 999px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    font-size: 12px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .ws-toggle-chip.is-on {
    background: #ecfdf5;
    border-color: #6ee7b7;
    color: #065f46;
  }

  .ws-toggle-chip.is-off {
    background: #f1f5f9;
    color: #64748b;
  }

  .ws-toggle-chip .MuiSwitch-root {
    margin-left: -6px;
  }

  .ws-highlight-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }

  .ws-highlight-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 4px 4px 10px;
    border-radius: 999px;
    background: var(--cms-selected-bg);
    color: var(--cms-text-primary);
    font-size: 12px;
    font-weight: 700;
  }

  .ws-highlight-chip .MuiIconButton-root {
    color: var(--cms-text-primary);
  }

  .ws-highlight-add {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border: 1px dashed var(--cms-border);
    border-radius: 999px;
    background: var(--cms-surface-secondary);
    color: var(--cms-text-secondary);
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }

  .ws-highlight-add:hover {
    border-color: var(--cms-border);
    color: var(--cms-text-primary);
  }

  .ws-advanced {
    margin-top: 4px;
    border-top: 1px dashed var(--cms-border);
    padding-top: 10px;
  }

  .ws-advanced-toggle {
    background: none;
    border: 0;
    color: var(--cms-text-secondary);
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    padding: 4px 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .ws-advanced-toggle:hover {
    color: var(--cms-text-primary);
  }

  .ws-advanced-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 10px;
  }

  @media (max-width: 700px) {
    .ws-advanced-grid {
      grid-template-columns: 1fr;
    }
  }

  .ws-perf-summary {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 12px;
  }

  @media (max-width: 900px) {
    .ws-perf-summary {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .ws-perf-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    padding: 10px 12px;
  }

  .ws-perf-card .label {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--cms-text-secondary);
  }

  .ws-perf-card .value {
    margin-top: 2px;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    line-height: 1.1;
  }

  .ws-perf-card .sub {
    margin-top: 2px;
    font-size: 11px;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  /* ---------- Welcome video section (Onboarding step 1) ---------- */

  .welcome-card {
    border: 1px solid var(--cms-border);
    border-radius: 16px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
    padding: 18px 18px 16px;
  }

  .welcome-card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }

  .welcome-card-title {
    margin: 0;
    font-size: 18px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .welcome-card-title-pill {
    background: #1d4ed8;
    color: #ffffff;
    font-size: 11px;
    font-weight: 800;
    padding: 2px 8px;
    border-radius: 999px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .welcome-card-subtitle {
    margin: 4px 0 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.45;
    max-width: 720px;
  }

  .welcome-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: var(--cms-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }

  .welcome-section-label {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--cms-text-primary);
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 18px 0 10px;
  }

  .welcome-section-label::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, var(--cms-border) 0%, transparent 100%);
  }

  .welcome-tiers-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(260px, 1fr));
    gap: 12px;
  }

  .welcome-products-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(280px, 1fr));
    gap: 12px;
  }

  .video-tile {
    position: relative;
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-secondary);
    padding: 12px 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .video-tile:hover {
    border-color: var(--cms-border);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
  }

  .video-tile.video-tile-empty {
    border-style: dashed;
    background: var(--cms-surface-muted);
  }

  .video-tile-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .video-tile-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--cms-text-primary);
    font-weight: 800;
    font-size: 14px;
    min-width: 0;
  }

  .video-tile-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tier-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 999px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .tier-pill.tier-free {
    background: #eef2f7;
    color: #475569;
  }

  .tier-pill.tier-silver {
    background: #e2e8f0;
    color: #334155;
  }

  .tier-pill.tier-gold {
    background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);
    color: #78350f;
  }

  .tier-pill.tier-platinum {
    background: linear-gradient(135deg, #ddd6fe 0%, #8b5cf6 100%);
    color: #ffffff;
  }

  .tier-pill.tier-product {
    background: linear-gradient(135deg, #bfdbfe 0%, #3b82f6 100%);
    color: #ffffff;
  }

  .tier-pill.tier-fallback {
    background: #fef3c7;
    color: #92400e;
  }

  .video-preview {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    overflow: hidden;
    background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
    border: 1px solid #1e293b;
  }

  .video-preview iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .video-preview-placeholder {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #94a3b8;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    padding: 12px;
  }

  .video-preview-placeholder .placeholder-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(148, 163, 184, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
  }

  .video-status.video-status-ok {
    color: #047857;
  }

  .video-status.video-status-warn {
    color: #b45309;
  }

  .video-status.video-status-empty {
    color: #64748b;
  }

  .video-tile-input {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .video-tile-input .MuiTextField-root {
    flex: 1;
  }

  .video-tile-actions {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .product-tile-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }

  .product-tile-head .MuiAutocomplete-root {
    flex: 1;
  }

  .welcome-empty-products {
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    padding: 28px 18px;
    text-align: center;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
  }

  .welcome-empty-products h4 {
    margin: 0 0 6px;
    color: var(--cms-text-primary);
    font-size: 15px;
    font-weight: 800;
  }

  .welcome-empty-products p {
    margin: 0 auto;
    max-width: 420px;
    font-size: 13px;
    line-height: 1.5;
  }

  .welcome-save-bar {
    position: sticky;
    bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    border: 1px solid var(--cms-border);
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12);
    backdrop-filter: blur(6px);
    margin-top: 16px;
    font-size: 13px;
    font-weight: 700;
    color: var(--cms-text-primary);
  }

  .welcome-save-bar .save-status {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .welcome-save-bar .save-status.dirty {
    color: #b45309;
  }

  .welcome-save-bar .save-status.clean {
    color: #047857;
  }

  @media (max-width: 900px) {
    .welcome-tiers-grid,
    .welcome-products-grid {
      grid-template-columns: 1fr;
    }
  }

  .stats-header {
    margin-bottom: 8px;
  }

  .stats-filter-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .stats-summary-row {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    margin: 8px 0 10px;
    color: var(--cms-text-primary);
    font-size: 12px;
    font-weight: 700;
  }

  @media (max-width: 900px) {
    .trigger-grid,
    .rotation-grid,
    .toggle-grid {
      grid-template-columns: 1fr;
    }

    .rotation-grid .rotation-highlights {
      grid-column: auto;
    }

    .toggle-item.global-toggle {
      grid-column: auto;
    }
  }
`;

const StyledModalDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  padding: 10px;

  .MuiPaper-root {
    width: min(940px, calc(100vw - 28px));
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .step-indicator {
    margin-top: 6px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .step-pill {
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-muted);
    color: var(--cms-text-secondary);
    border-radius: 999px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.01em;
  }

  .step-pill.active {
    border-color: var(--cms-border);
    background: var(--cms-selected-bg);
    color: var(--cms-text-primary);
  }

  .MuiDialogContent-root {
    padding: 14px 24px 10px;
  }

  .dialog-field-group {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .campaign-builder {
    margin-top: 4px;
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-muted);
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .campaign-builder-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .campaign-builder-title {
    margin: 0;
    font-size: 16px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .campaign-builder-subtitle {
    margin: 0;
    font-size: 12px;
    color: var(--cms-text-secondary);
    line-height: 1.45;
    font-weight: 500;
  }

  .campaign-builder-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 10px;
  }

  .builder-media-dropzone {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    min-height: 170px;
    overflow: hidden;
    cursor: pointer;
  }

  .builder-media-empty {
    min-height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--cms-text-secondary);
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    padding: 14px;
  }

  .builder-plus {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
    color: #2563eb;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
    line-height: 1;
  }

  .builder-media-frame,
  .builder-media-image {
    width: 100%;
    display: block;
    aspect-ratio: 16 / 9;
    border: none;
    object-fit: cover;
    background: #000;
  }

  .builder-media-selected {
    padding: 10px;
  }

  .graphic-option-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
  }

  .builder-media-actions {
    display: flex;
    justify-content: flex-start;
  }

  .builder-card {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    padding: 12px;
  }

  .builder-card-title {
    margin: 0 0 8px;
    color: var(--cms-text-primary);
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -0.01em;
  }

  .builder-card-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 14px;
    line-height: 1.5;
    min-height: 42px;
  }

  .builder-card-button {
    margin-top: 12px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(135deg, #5f82ff, #2fa6ff);
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    padding: 9px 14px;
  }

  .campaign-builder-grid .MuiFormControlLabel-root {
    margin-left: 0;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    min-height: 40px;
    background: var(--cms-surface-secondary);
    padding: 0 10px;
    justify-content: space-between;
  }

  .campaign-builder-grid .MuiFormControlLabel-label {
    font-size: 13px;
    color: var(--cms-text-primary);
    font-weight: 600;
  }

  .video-controls-save-toggle {
    margin-left: 4px;
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-width: 108px;
    min-height: 40px;
    font-weight: 700;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .error {
    font-size: 12px;
    color: #b91c1c;
    margin-top: 3px;
    font-weight: 600;
  }

  @media (max-width: 1040px) {
    .graphic-option-grid {
      grid-template-columns: 1fr 1fr;
    }

    .campaign-builder-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .content-shell {
    border: 1px solid var(--cms-border);
    border-radius: 16px;
    padding: 12px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
  }

  .header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .header-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .header-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .header-actions .actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .header-action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 36px;
    padding: 6px 12px;
  }

  .campaign-builder {
    margin: 12px 0 14px;
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    background: var(--cms-surface-muted);
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .campaign-builder-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .campaign-builder-title {
    margin: 0;
    font-size: 16px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .campaign-builder-subtitle {
    margin: 0;
    font-size: 12px;
    color: var(--cms-text-secondary);
    line-height: 1.45;
    font-weight: 500;
  }

  .campaign-builder-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 10px;
  }

  .campaign-builder-grid .MuiFormControlLabel-root {
    margin-left: 0;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    min-height: 40px;
    background: var(--cms-surface-secondary);
    padding: 0 10px;
    justify-content: space-between;
  }

  .campaign-builder-grid .MuiFormControlLabel-label {
    font-size: 13px;
    color: var(--cms-text-primary);
    font-weight: 600;
  }

  .campaign-builder-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .advanced-block-title {
    font-size: 12px;
    color: var(--cms-text-secondary);
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .content-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-size: 14px;
    font-weight: 600;
    padding: 20px 14px;
    background: var(--cms-surface-muted);
  }

  .smooth-dnd-container {
    display: flex;
    flex-direction: column;
    width: min(100%, 900px);
    margin: 0 auto;
    gap: 10px;
  }

  .modal-content-card {
    padding: 14px;
    border-radius: 12px;
    background: var(--cms-surface-secondary);
    border: 1px solid var(--cms-border);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;

    .modal-content-card-detail {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: flex-start;
      gap: 10px;
      flex-wrap: wrap;
    }

    .modal-content-preview {
      min-width: 180px;
      flex: 1;
    }

    .modal-content-preview .MuiTextField-root {
      width: 100%;
    }

    .control-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 164px;
      align-items: stretch;
      gap: 8px;
      flex-shrink: 0;
    }

    .control-block .MuiChip-root {
      border-radius: 999px;
      border: 1px solid #dbe7ff;
      background: #edf4ff;
      color: #1e40af;
      font-weight: 700;
    }

    .content-action-btn {
      text-transform: none;
      font-weight: 700;
      border-radius: 9px;
      min-height: 34px;
      padding: 5px 10px;
    }

    .content-action-btn.delete {
      color: #b91c1c;
      border-color: #fecaca;
      background: #fef2f2;
      &:hover {
        border-color: #fca5a5;
        background: #fee2e2;
      }
    }
  }

  @media (max-width: 1040px) {
    .campaign-builder-grid {
      grid-template-columns: 1fr;
    }

    .modal-content-card {
      flex-direction: column;
    }

    .modal-content-card .control-block {
      width: 100%;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
    }

    .modal-content-card .content-action-btn {
      min-width: 120px;
    }
  }
`;

const StyledModalContentDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  padding: 10px;

  .control-label {
    font-size: 14px;
    color: var(--cms-text-primary);
    margin: 6px 0 8px;
    font-weight: 700;
  }

  .resource-hint {
    margin-left: 6px;
    font-size: 12px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiPaper-root {
    width: min(920px, calc(100vw - 28px));
    min-height: 560px;
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 14px 24px 10px;
  }

  .dialog-field-group {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-width: 108px;
    min-height: 40px;
    font-weight: 700;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .error {
    font-size: 12px;
    color: #b91c1c;
    margin-top: 3px;
    font-weight: 600;
  }

  .resource-block {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 10px;
  }

  .resource-block .resource-body {
    margin-top: 8px;
  }
`;

export {
  StyledModal,
  StyledModalDialog,
  StyledModalContent,
  StyledModalContentDialog,
};
